/** @WORKAROUND CODE:
 * Фильтруется узлы по принадлежности к ЕМД
 * Исключает узлы относящиеся к SKOS и SDMX */
// Вариант с создание узлов 
// var propertyPrototypeMap = require("../../../webvowl/elements/properties/propertyMap")();
// function uuidv4() {
//   return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
//     (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
//   );
// }
// function createLowerCasePrototypeMap(prototypeMap) {
// 	return d3.map(prototypeMap.values(), function (Prototype) {
// 		return new Prototype().type().toLowerCase();
// 	});
// }
// ----------------------- Код в filter.filter
// 		var prototypeMap = createLowerCasePrototypeMap(propertyPrototypeMap);
// 		var Prototype = prototypeMap.get("owl:namedindividual");
// 		for (i = 0; i < nodes.length; i++) {
// 			newNodes.push(nodes[i]);
// 			if (nodes[i].type() === "owl:Class") {
// 				if (nodes[i].individuals()){
// 					for (let index = 0; index < nodes[i].individuals().length; index++) {
// 						newNodes.push(nodes[i].individuals()[index]);						
// 						//Теперь добавим связь с родителем
// 						var property = new Prototype(graph);
// 						property.id(uuidv4())
// 							.domain(nodes[i].individuals()[index])
// 							.inverse(false)
// 							.range(nodes[i])
// 							.visible(true);
// //							.attributes([ "object", "anonymous" ]);
// //						console.log("var property = new Prototype(graph);", property, properties);
// 						properties.push(property);
// 					}				
// 				}
// 			}
// 		}

const excludeNodesIRI = [
	"http://www.w3.org/2002/07/owl#Thing",
	"http://www.w3.org/2004/02/skos/core#ConceptScheme",
	"http://www.w3.org/2004/02/skos/core#Concept",
	"http://www.w3.org/2004/02/skos/core#OrderedCollection",
	"http://www.w3.org/2004/02/skos/core#Collection",
	"http://www.w3.org/1999/02/22-rdf-syntax-ns#List",
	"http://open-services.net/ns/cm#task",
	"http://hbz.ru/ontologies/emd/sdmx", 
	"http://hbz.ru/ontologies/emd/DataStructureDefinition",
	"http://hbz.ru/ontologies/emd/HBZRootElement"];

module.exports = function (graph) {

	var filter = {},
		enabled=true,
		filteredNodes,
		removedNodes,
		filteredProperties;

	filter.enabled=function(val){
		if (!arguments.length){
            return enabled;
		}
        enabled=val;
	};

	function isIncludeNode (node) {
		if (node && node.type() === "owl:Class"){
			const iri = (node.iri())? node.iri(): "";
			return !excludeNodesIRI.includes(iri);
		}
		return true;
	};

	filter.filter = function (nodes, properties) {
		if (enabled===false){
			filteredNodes=nodes;
			filteredProperties=properties;
      removedNodes=[];
			return;
		}
		var nodesToRemove = [];
		var newNodes = [];
		//Удалим узлы, относящиеся к SKOS и скроем корневой ЕМД
		for (i = 0; i < nodes.length; i++) {
			var nodeId = nodes[i].id();
			if (isIncludeNode(nodes[i])) {
					newNodes.push(nodes[i]);
				} else {
					nodesToRemove.push(nodeId);
				}
		}

		properties = removeProperties(properties);
		filteredNodes = newNodes;
		filteredProperties = properties;
		removedNodes = nodesToRemove;
		//console.log("emdNodesFilter", nodes, properties, filteredNodes, filteredProperties, removedNodes);
	};

	function removeProperties(properties) {
		var cleanedProperties = [],
			i, l, property;

		for (i = 0, l = properties.length; i < l; i++) {
			property = properties[i];
			if ((property.type() == "rdfs:subClassOf")||(property.type() == "owl:NamedIndividual")){
				//console.log("property", property)
				if (!isIncludeNode(property.domain())) continue;
				if (!isIncludeNode(property.range())) continue;
				cleanedProperties.push(property);
			}
			// if (!(property instanceof OwlDisjointWith)) {
			// 	cleanedProperties.push(property);
			// }
		}

		return cleanedProperties;
	}


	// Functions a filter must have
	filter.filteredNodes = function () {
		return filteredNodes;
	};

	filter.removedNodes = function () {
		return removedNodes;
	};

	filter.filteredProperties = function () {
		return filteredProperties;
	};

	return filter;
};
